<div style="height: 100%; width: 100%">
  <table
    style="
      height: 100%;
      width: 100%;
      border-collapse: separate;
      border-spacing: 5px;
    "
  >
    <tr style="height: 5%">
      <th
        class="header-color"
        style="border-radius: 3px; width: 33%"
      >
        <div style="position: relative">
          <div style="position: relative; z-index: 3">
            <button
              id="checkout-cancel-btn"
              style="
                display: flex;
                padding: 5px;
                margin-left: 2px;
                background: lightgrey;
                border-radius: 3px;
              "
              (click)="cancel()"
            >
            {{ 'General.Back' | translate }}
            </button>
          </div>
          <div
            style="text-align: center; position: absolute; width: 100%; top: 0%"
          >
            <h2 style="font-size: 18px !important; margin: 0px; padding: 0px">
              {{ "Nav.Login" | translate }}
            </h2>
          </div>
        </div>
      </th>
      <th
        class="header-color"
        style="border-radius: 3px; width: 33%"
      >
        <h2
          style="
            text-align: center;
            font-size: 18px !important;
            margin: 0px;
            padding: 0px;
          "
        >
          {{ "Nav.Checkout" | translate }}
        </h2>
      </th>
      <th
        class="header-color"
        style="border-radius: 3px; width: 33%"
      >
        <h2
          style="
            text-align: center;
            font-size: 18px !important;
            margin: 0px;
            padding: 0px;
          "
        >
          {{ "Nav.Cart" | translate }}
        </h2>
      </th>
    </tr>
    <tr style="height: 95%">
      <td>
        <app-login-desktop-modal (onNavigate)="cancel()" (onLogin)="loadProfile()"></app-login-desktop-modal>
      </td>
      <td>
        <app-checkout-desktop-modal #checkoutComponent
          [order]="order"
          [store]="store"
        ></app-checkout-desktop-modal>
      </td>
      <td>
        <app-cart-desktop-modal
          [order]="order"
          [store]="store"
          [checkTwoForOneDiscounts]="checkTwoForOneDiscounts"
        ></app-cart-desktop-modal>
      </td>
    </tr>
  </table>
</div>